import script from "./PaymentReportFormSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentReportFormSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./PaymentReportFormSkeleton.vue?vue&type=style&index=0&id=357f5faa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357f5faa"]])

export default __exports__